var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"Usuários"}},[(_vm.canManageUsers)?_c('user-management'):_vm._e(),(_vm.canViewLastLogins)?_c('users-last-logins'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }